import type { ReactNode } from 'react';

import { cn } from '@/shared/lib';

/**
 * Eén blok van de klantpagina. De horizontale padding schaalt mee met de
 * *container* (niet met het venster), zodat de pagina zowel op 360 px als in
 * de 780 px brede kolom klopt - en in de admin-preview net zo goed.
 */
export function PublicBlock({
    children,
    className,
    last = false,
    as,
}: {
    children: ReactNode;
    className?: string;
    /** Het laatste blok krijgt geen scheidingslijn. */
    last?: boolean;
    as?: 'div' | 'section' | 'footer';
}) {
    const Tag = as ?? 'section';

    return (
        <Tag
            className={cn(
                'px-[var(--pr-pad-x)] py-6',
                !last && 'border-b border-[var(--border-subtle)]',
                className,
            )}
        >
            {children}
        </Tag>
    );
}
